import { isStoryEligible } from './extraRounds';

/** Skriveleg — efter niveau 3 (som Fortælling). */
export function isSkrivelegEligible(
  user: Parameters<typeof isStoryEligible>[0],
): boolean {
  return isStoryEligible(user);
}
